// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_n2-0";